import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button } from "@/components/button";
import { FormInput, FormTextarea, FormSelect, FormDate } from "@/components/form";
import { LinkedRecordsPanel } from "@/components/linked-records-panel";
import { DueDateShortcuts } from "@/components/task-detail";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { TITLE_MAX_LENGTH, CONTEXT_MAX_LENGTH } from "./create-task-constants";
/** All editable fields for a new task: type, title, description, due date, owner, and linked records. */
export function CreateTaskForm(_ref) {
  var formState = _ref.formState,
    onChangeTitle = _ref.onChangeTitle,
    onChangeContext = _ref.onChangeContext,
    onChangeDate = _ref.onChangeDate,
    onChangeOwner = _ref.onChangeOwner,
    onChangeLabel = _ref.onChangeLabel,
    labelOptions = _ref.labelOptions,
    ownerOptions = _ref.ownerOptions,
    onOpenLinkRecords = _ref.onOpenLinkRecords,
    onViewRecords = _ref.onViewRecords;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isLinkedResourcesEmpty = formState.linkedResources.reports.length === 0 && formState.linkedResources.appointments.length === 0 && formState.linkedResources.encounters.length === 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-5 p-4 overflow-y-auto scrollbar-sds flex-1"
  }, /*#__PURE__*/React.createElement(FormSelect, {
    "data-testid": "create-task-label",
    placeholder: t("label.select_task_type"),
    data: labelOptions,
    value: formState.labelId,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.CREATE_TASK_LABEL);
      onChangeLabel(value);
    },
    clearable: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col rounded-sds-200 border border-sds-base-default overflow-hidden divide-y divide-sds-base-default"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(FormInput, {
    "data-testid": "create-task-title-input",
    placeholder: "",
    value: formState.title,
    maxLength: TITLE_MAX_LENGTH,
    showCharacterCount: true,
    classNames: {
      input: "!border-0 !shadow-none !rounded-none"
    },
    onChange: function onChange(e) {
      return onChangeTitle(e.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.CREATE_TASK_TITLE_INPUT);
    }
  }), formState.title ? null : /*#__PURE__*/React.createElement("span", {
    className: "pointer-events-none absolute inset-y-0 left-3 flex items-center text-sm text-sds-base-secondary"
  }, t("label.title"), /*#__PURE__*/React.createElement("span", {
    className: "text-md text-sds-urgent-default"
  }, "*"))), /*#__PURE__*/React.createElement(FormTextarea, {
    "data-testid": "create-task-context-input",
    placeholder: t("label.reminder_add_description"),
    value: formState.context,
    maxLength: CONTEXT_MAX_LENGTH,
    showCharacterCount: true,
    minRows: 10,
    classNames: {
      input: "!border-0 !shadow-none !rounded-none"
    },
    onChange: function onChange(e) {
      return onChangeContext(e.currentTarget.value);
    },
    onBlur: function onBlur() {
      return trackEvent(ANALYTICS_EVENTS.CREATE_TASK_CONTEXT_INPUT);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 flex-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-caps text-sds-base-tertiary"
  }, t("label.due_date"), " ", /*#__PURE__*/React.createElement("span", {
    className: "text-sds-urgent-default"
  }, "*")), /*#__PURE__*/React.createElement(FormDate, {
    value: formState.remindAfter,
    onChange: onChangeDate,
    testId: "create-task-due-date",
    highlightToday: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 flex-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-caps text-sds-base-tertiary"
  }, t("label.task_owner"), " ", /*#__PURE__*/React.createElement("span", {
    className: "text-sds-urgent-default"
  }, "*")), /*#__PURE__*/React.createElement(FormSelect, {
    "data-testid": "create-task-owner",
    placeholder: t("select_key"),
    data: ownerOptions,
    value: formState.ownedBy,
    onChange: function onChange(value) {
      trackEvent(ANALYTICS_EVENTS.CREATE_TASK_OWNER);
      onChangeOwner(value);
    },
    searchable: true,
    clearable: true
  }))), formState.remindAfter && /*#__PURE__*/React.createElement(DueDateShortcuts, {
    currentDate: formState.remindAfter,
    onBump: onChangeDate
  })), isLinkedResourcesEmpty ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-style-label-caps text-sds-base-tertiary"
  }, t("label.link_patient_records", {
    defaultValue: "Link patient records"
  })), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "create-task-select-patient-record",
    variant: "secondary",
    leftIcon: faPlus,
    className: "w-full",
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.CREATE_TASK_SELECT_PATIENT_RECORD);
      onOpenLinkRecords();
    }
  }, t("label.select_patient_record", {
    defaultValue: "Select patient record"
  }))) : /*#__PURE__*/React.createElement(LinkedRecordsPanel, {
    linkedResources: formState.linkedResources,
    onAddRecords: onOpenLinkRecords,
    onViewRecords: onViewRecords
  }));
}